import * as React from "react";
import { Device } from "../../models/Device";
import DeviceMapPopup from "./DeviceMapPopup";
import s from "./index.module.scss";

interface IClusterMapPopupProps {
	devices: (Device | undefined)[] | undefined;
	onClick?: (device: Device) => void;
}

const ClusterMapPopup = ({ devices = [], onClick }: IClusterMapPopupProps) => {
	const [index, setIndex] = React.useState<number>(0);

	const disabledPrev: boolean = index === 0;
	const disabledNext: boolean = !!devices && index === (devices.length - 1);

	React.useEffect(() => {
		setIndex(0);
	}, [devices?.length]);

	const togglePrev = () => {
		if (!disabledPrev) {
			setIndex(index - 1);
		}
	};

	const toggleNext = () => {
		if (!disabledNext) {
			setIndex(index + 1);
		}
	};

	return (
		<div className={s.popup}>
			<DeviceMapPopup device={devices[index]} onClick={onClick}/>
			<div className={s.links}>
				<a onClick={togglePrev} className={[s.link, disabledPrev ? s.link_disabled : ""].join(" ")}>Prev</a>
				<a onClick={toggleNext} className={[s.link, disabledNext ? s.link_disabled : ""].join(" ")}>Next</a>
			</div>
		</div>
	);
};

export default ClusterMapPopup;
